import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  FormControlLabel,
  TableRow,
  ListItemText,
  TableCell,
  TableBody,
  Avatar,
  Box,
  Grid,
  TextField,
  OutlinedInput,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
  InputLabel,
} from "@mui/material";
import Page from '../components/Page';
import { getEntryAndExit } from "src/api/faceRegistration";
import { useNavigate } from "react-router-dom"; // if using React Router
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Label from "src/components/Label";
import { id } from "date-fns/locale";
import { getURL } from "src/utils/config";
import axios from "axios";


export default function NeterwalaDashboard() {
  const [ipAddress, setIpAddress] = useState("");

  //Ip address
  const [disableGetButton, setDisableButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [streamCamera, setStreamCamera] = useState(null);
  const [streamCameraexit, setStreamCameraExit] = useState(null);

  // const [baseURL,setBaseURL] = useState(null);

  //Stream video
  const [streamStatus, setStreamStatus] = useState(null);

  const [faceAngleStep, setFaceAngleStep] = useState({
    step: 0,
    isProcess: false,
    status: null,
    images: [],
    is_display_instruction: false,
    stepIndexing: 0,
    message: null,
  });
  //Table Data
  const [entryDatalast, setEntryDataLast] = useState([]);
  const [exitDatalast, setExitDataLast] = useState([]);
  const [entryUser, setEntryUser] = useState([]);
  const [exitUser, setExitUser] = useState([]);
  const [lastUpdatedTime, setLastUpdatedTime] = useState('');
  const lastUpdatedTimeRef = useRef('');
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [apiData, setApiData] = useState(null); 
  const [locationNames, setLocationNames] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const intervalRef = useRef(null);

  const navigate = useNavigate();

  const handleViewAll = (type) => {
    if(["entry", "exit"].includes(type)){
      navigate(`/entry-face-details?tab=${type}&location=${selectedLocation}&view=list`);
    }
  };

  const handleIpChange = (event) => {
    setIpAddress(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      
      const apiUrl = getURL("employee-shifts-info/location-names?status=1");
      const AUTH_TOKEN = `${localStorage.getItem('token_type')} ${localStorage.getItem('access_token')}`;
      
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const extractedLocationNames = response.data.map(item => item.LocationName);
        setLocationNames(extractedLocationNames);
        setApiData(response.data);
      } catch (error) {
        console.error('Error:', error);
      }
    };
  
    fetchData();
  }, []);

  
  const updateLocation = (value) => {
    setSelectedLocation(value);
    const selectedLocationObject = apiData.find((location) => location.LocationName === value);
    const locationId = selectedLocationObject ? selectedLocationObject.Id : null;
    if(locationId){
      entryAndExitdata(locationId);
    }
    setSelectedLocationId(locationId);
    localStorage.setItem("NetLocation", value);
  };

  const handleLocationChange = (value) => {
     updateLocation(value);
  };

  useEffect(() => {
    const savedLocation = localStorage.getItem("NetLocation");
    const ipAddress = localStorage.getItem("netIP");

    if(savedLocation && apiData) {
      updateLocation(savedLocation);
    }

    if (ipAddress) {
      setIpAddress(ipAddress);
      handleGetIP(ipAddress);
    }

  }, [apiData]);


  useEffect(() => {
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // If selectedLocationId is not 0, start polling every 5 seconds
    if (selectedLocationId) {
    entryAndExitdata(selectedLocationId); // call once immediately
    intervalRef.current = setInterval(() => {
      entryAndExitdata(selectedLocationId);
    }, 3000);
    }

    // Cleanup on unmount or when selectedLocationId changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [selectedLocationId]);

  const entryAndExitdata1 = (localId) => {
    // console.log("entry data and exit data ============", lastUpdatedTime);
    const data = {
      location_id: localId,
      limit: 5,
      last_updated_time:lastUpdatedTimeRef.current ?lastUpdatedTimeRef.current: "",
    };
    getEntryAndExit(data, (response) => {
      if (response.status === 200 && response.data !== null) {
        // console.log("entry and exit data", response.data.last_updated_time);
        let updatedTime = response.data.last_updated_time;

        lastUpdatedTimeRef.current = updatedTime;
        setLastUpdatedTime(updatedTime);         // if(data.location_id === 1){
        //   setEntryDataLast(response.data)
        // }
        // else if(data.location_id === 2){
        //   setExitDataLast(response.data)
        // }
        // else{
        setLastUpdatedTime(updatedTime);
        const updateDateLocation1 = response.data.combined_data
          .filter((item) => item.Direction === "entry")
          .slice(0, 3);
        const updateDateLocation2 = response.data.combined_data
          .filter((item) => item.Direction === "exit")
          .slice(0, 3);

        // console.log("entry and exit data usedheuoehoud", updateDateLocation1);
        setEntryUser(response.data.latest_entry_record);
        setExitUser(response.data.latest_exit_record);
        setEntryDataLast(updateDateLocation1);
        setExitDataLast(updateDateLocation2);

        // }
      }
    });
  };



  const lastEntryUpdateTimeRef = useRef(0);
  const lastExitUpdateTimeRef = useRef(0);
  const lastEntryIdRef = useRef(null);
  const lastExitIdRef = useRef(null);
  
  const MIN_UPDATE_INTERVAL = 10000; // 5 seconds
  
  const entryAndExitdata = (localId) => {
    const data = {
      location_id: localId,
      limit: 5,
      last_updated_time: lastUpdatedTimeRef.current || "",
    };
  
    getEntryAndExit(data, (response) => {
      if (response.status === 200 && response.data) {
        const updatedTime = response.data.last_updated_time;
        lastUpdatedTimeRef.current = updatedTime;
        setLastUpdatedTime(updatedTime);
  
        const entryList = response.data.combined_data
          .filter((item) => item.Direction === "entry")
          .slice(0, 3);
        const exitList = response.data.combined_data
          .filter((item) => item.Direction === "exit")
          .slice(0, 3);
  
        const now = Date.now();
  
        const latestEntry = response.data.latest_entry_record;
        const latestExit = response.data.latest_exit_record;
  
        // Assuming each record has a unique id or timestamp like 'person_id' or 'entry_id'
        const entryId = latestEntry?.person_id || latestEntry?.id || null;
        const exitId = latestExit?.person_id || latestExit?.id || null;
  
        // Entry update condition
        if (
          entryId !== lastEntryIdRef.current || // It's a new person
          now - lastEntryUpdateTimeRef.current >= MIN_UPDATE_INTERVAL // Or 5 seconds have passed
        ) {
          setEntryUser(latestEntry);
          lastEntryIdRef.current = entryId;
          lastEntryUpdateTimeRef.current = now;
        }
  
        // Exit update condition
        if (
          exitId !== lastExitIdRef.current ||
          now - lastExitUpdateTimeRef.current >= MIN_UPDATE_INTERVAL
        ) {
          setExitUser(latestExit);
          lastExitIdRef.current = exitId;
          lastExitUpdateTimeRef.current = now;
        }
  
        setEntryDataLast(entryList);
        setExitDataLast(exitList);
      }
    });
  };
  

  const handleGetIP = (ipAddress) => {
    // console.log("==========");
    // Updated regex to validate IP addresses correctly
    const validIP =
      /^(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4][0-9]|1\d{2}|\d{1,2})$/;

    if (validIP.test(ipAddress)) {
      // console.log("Valid IP Address:", ipAddress);

      const port = process.env.REACT_APP_PORT;
      // console.log("Port from .env:", port);

      const apiUrl = `http://${ipAddress}:${port}/`;
      // console.log("Calling API:", apiUrl);

      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem("netIP", ipAddress);
            setDisableButton(true);
            setErrorMessage(""); // Clear previous errors
            return response.json();
          } else {
            setErrorMessage(`Error: HTTP ${response.status}`);
            throw new Error(`HTTP Error: ${response.status}`);
          }
        })
        .then((data) => {
          // console.log("API Response:", data.entry_live);
          setStreamCamera(data.entry_live);
          setStreamCameraExit(data.exit_live);
          // setBaseURL(data.face_detection_base_url);
          localStorage.setItem("deleteURL",data.face_detection_base_url);
        })
        .catch((error) => {
          //console.error("API Error:", error);
          setErrorMessage(
            "Please enter a valid IP address or check network connection."
          );
        });
    } else {
      //console.error("Invalid IP Address:", ipAddress);
      setErrorMessage("Invalid IP format. Please enter a valid IPv4 address.");
    }
  };

  // Dummy API Data (Replace with API Response)

  const [exitData, setExitData] = useState({
    name: "Jane Smith",
    age: 32,
    location: "Los Angeles",
    exitTime: "12:45 PM",
    profilePic: "https://via.placeholder.com/100",
  });
  const [entryData, setEntryData] = useState({
    name: "Jane Smith",
    age: 32,
    location: "Los Angeles",
    exitTime: "12:45 PM",
    profilePic: "https://via.placeholder.com/100",
  });
  const [tableData, setTableData] = useState([
    { id: 1, event: "Checked In", time: "10:30 AM" },
    { id: 2, event: "Checked Out", time: "12:45 PM" },
  ]);



  const handleMultiSelectToggle = (e) => {
    setIsMultiSelect(e.target.checked);
    // Reset selection when toggling
    setSelectedLocation('');
  };

  const avatarColors = [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#3f51b5",
    "#2196f3",
    "#03a9f4",
    "#00bcd4",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#cddc39",
    "#ff9800",
    "#ff5722",
    "#795548",
    "#607d8b",
  ];

  const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarColors.length;
    return avatarColors[index];
  };

  return (
    <Page title="Face Recognition Details">
      <div style={{ width: "100%", padding: "20px"}}>
        {/* Top Bar with IP Address Input */}
        <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
          <Grid item>
            <FormControl size="small" style={{ minWidth: 200 }}>
              <InputLabel id="select-label">Location</InputLabel>
              <Select
                labelId="select-label"
                value={selectedLocation}
                onChange={(e) => handleLocationChange(e.target.value)}
                input={<OutlinedInput label="Select Location" />}
              >
                {locationNames.map((option) => (
                  <MenuItem key={option} value={option}>
                    <ListItemText primary={option} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <TextField
              label="Enter IP Address"
              variant="outlined"
              size="small"
              error={Boolean(errorMessage)} // Show error styling
              helperText={errorMessage} // Display error message below TextField
              value={ipAddress}
              onChange={handleIpChange}
            />
          </Grid>

          <Grid item>
            <Button
              type="submit"
              onClick={() => handleGetIP(ipAddress)}
              variant="contained"
            >
              Get
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={1}>
          {/* Entry Card */}
          <Grid item xs={6}>
            <Card sx={{ boxShadow: 3, borderRadius: 3 }}>
              <CardContent>
                {/* Header */}
                <Typography variant="h6" align="left" gutterBottom>
                  Entry Direction Camera
                </Typography>


                {/* Video & User Info */}
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    {streamCamera ? (
                    <img src={streamCamera} alt="Live Stream" style={{ width: '100%' }} />
                    ) : (
                      <Box
                        sx={{
                          width: "105%",
                          minHeight: 350,
                          backgroundColor: "black",
                          textAlign: "center",
                          display: faceAngleStep.is_display_instruction,
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={4} textAlign="center">
                  <Avatar
    src={entryUser.Snapshot ? entryUser.Snapshot : undefined}
    sx={{
      width: 80,
      height: 80,
      margin: "auto",
      backgroundColor: entryUser.Snapshot ? "transparent" : "gray",
    }}
  >
    {!entryUser.Snapshot && "NA"}
  </Avatar>

  <Typography variant="body2" sx={{ mt: 1, textAlign: "left", ml: 6 }}>
    <strong style={{ color: entryUser.Name ? "inherit" : "gray" }}>
      Name:
    </strong>{" "}
    {entryUser.Name ? entryUser.Name : "NA"} <br />

    <strong style={{ color: entryUser.LocationName ? "inherit" : "gray" }}>
      Location:
    </strong>{" "}
    {entryUser.LocationName ? entryUser.LocationName : "NA"} <br />

    <strong style={{ color: entryUser.FaceTime ? "inherit" : "gray" }}>
      Entry Time:
    </strong>{" "}
    {entryUser.FaceTime ? entryUser.FaceTime : "NA"}

    <br />

    <strong style={{ color: exitUser.ProcessStatus ? "inherit" : "gray" }}>
      Status:
    </strong>{" "}
    {entryUser?.Status === 1
    ? "Active"
    : entryUser?.Status == 0
    ? "Terminated"
    : entryUser?.Status == 2
    ? "InActive"
    : "NA"}

  </Typography>

                  </Grid>
                </Grid>
              </CardContent>

              {/* Recent Entries Header - Full Width */}
              {/* <Box
                sx={{
                  backgroundColor: "#fff",
                  borderTop: "1px solid #eee",
                  borderBottom: "1px solid #eee",
                  padding: "16px 24px",
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  Recent Entries
                </Typography>
              </Box> */}

              {/* Scrollable Table - Full Width */}
              <Box sx={{ maxHeight: 450, overflowY: "auto", px: 0 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Entry Time</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Status</TableCell>

                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {entryDatalast.length > 0 ? (
                      entryDatalast.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>

                          <TableCell>
                            <Box display="flex" alignItems="center">
                              <Avatar
                                sx={{
                                  bgcolor: stringToColor(row.Name),
                                  width: 32,
                                  height: 32,
                                  fontSize: 16,
                                }}
                              >
                                {row.Name.charAt(0).toUpperCase()}
                              </Avatar>
                              <Typography
                                variant="body2"
                                sx={{ ml: 1, fontWeight: 500 }}
                              >
                                {row.Name}
                              </Typography>
                            </Box>
                          </TableCell>

                          <TableCell>{row.FaceTime}</TableCell>
                          <TableCell>{row.LocationName || "N/A"}</TableCell>
                          <TableCell>
                            <Label
                              variant="ghost"
                              color={row.Status === 1 ? "success" : "error"}
                            >
                            {row.Status === 1 ? "Active": "Terminated"|| "N/A"}
                            </Label>
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          No data
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>

              {/* View All button - bottom right full width*/}

              <Box
                sx={{ display: "flex", justifyContent: "flex-end", px: 3, py: 2 }}
              >
                <Button
                  variant="contained"
                  size="small"
                  endIcon={<ArrowForwardIcon />}
                  onClick={() => handleViewAll("entry")}
                  sx={{
                    fontWeight: 600,
                    color: "#fff",
                    borderRadius: "20px",
                    px: 2,
                    textTransform: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#fff",
                      transform: "translateX(2px)",
                      boxShadow: "0 4px 10px rgba(13,92,136,0.3)",
                    },
                  }}
                >
                  View All
                </Button>
              </Box>
            </Card>
          </Grid>

          {/* Exit Card */}
          <Grid item xs={6}>
            <Card sx={{ boxShadow: 3, borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" align="left" gutterBottom>
                  Exit Direction Camera
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  {/* Video */}
                  <Grid item xs={8}>
                    {streamCameraexit ? (
                      <img src={streamCameraexit} alt="Live Stream" style={{ width: '100%' }} />
                    ) : (
                      <Box
                        sx={{
                          width: "105%",
                          minHeight: 350,
                          backgroundColor: "black",
                          textAlign: "center",
                          display: faceAngleStep.is_display_instruction,
                        }}
                      />
                    )}
                  </Grid>

                  {/* User Details */}
                  <Grid item xs={4} textAlign="center">
                  <Avatar
    src={exitUser.Snapshot ? exitUser.Snapshot : undefined}
    sx={{
      width: 80,
      height: 80,
      margin: "auto",
      backgroundColor: exitUser.Snapshot ? "transparent" : "gray",
    }}
  >
    {!exitUser.Snapshot && "NA"}
  </Avatar>

  <Typography variant="body2" sx={{ mt: 1, textAlign: "left", ml: 6 }}>
    <strong style={{ color: exitUser.Name ? "inherit" : "gray" }}>
      Name:
    </strong>{" "}
    {exitUser.Name ? exitUser.Name : "NA"} <br />
    
    <strong style={{ color: exitUser.LocationName ? "inherit" : "gray" }}>
      Location:
    </strong>{" "}
    {exitUser.LocationName ? exitUser.LocationName : "NA"} <br />
    
    <strong style={{ color: exitUser.FaceTime ? "inherit" : "gray" }}>
      Exit Time:
    </strong>{" "}
    {exitUser.FaceTime ? exitUser.FaceTime : "NA"}  <br />

    <strong style={{ color: exitUser.ProcessStatus ? "inherit" : "gray" }}>
      Status:
    </strong>{" "}
    {exitUser?.Status === 1
    ? "Active"
    : exitUser?.Status == 0
    ? "Terminated"
    : exitUser?.Status == 2
    ? "InActive"
    : "NA"}
  </Typography>

                  </Grid>
                </Grid>
              </CardContent>

              {/* Recent Exits Header */}
              {/* <Box
                sx={{
                  backgroundColor: "#fff",
                  borderTop: "1px solid #eee",
                  borderBottom: "1px solid #eee",
                  padding: "16px 24px",
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold">
                  Recent Exits
                </Typography>
              </Box> */}

              {/* Scrollable Table - Full Width */}
              <Box sx={{ maxHeight: 550, overflowY: "auto", px: 0 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>S.No</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Exit Time</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {exitDatalast.length > 0 ? (
                      exitDatalast.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>

                          <TableCell>
                            <Box display="flex" alignItems="center">
                              <Avatar
                                sx={{
                                  bgcolor: stringToColor(row.Name),
                                  width: 32,
                                  height: 32,
                                  fontSize: 16,
                                }}
                              >
                                {row.Name.charAt(0).toUpperCase()}
                              </Avatar>
                              <Typography
                                variant="body2"
                                sx={{ ml: 1, fontWeight: 500 }}
                              >
                                {row.Name}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>{row.FaceTime}</TableCell>
                          <TableCell>{row.LocationName || "N/A"}</TableCell>
                          <TableCell>
                            <Label
                              variant="ghost"
                              color={row.Status === 1 ? "success" : "error"}
                            >
                            {row.Status === 1 ? "Active": "Terminated"|| "N/A"}
                            </Label>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          No data
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>

              {/* View All Button */}
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", px: 3, py: 2 }}
              >
                <Button
                  variant="contained"
                  size="small"
                  endIcon={<ArrowForwardIcon />}
                  onClick={() => handleViewAll("exit")}
                  sx={{
                    fontWeight: 600,
                    color: "#fff",
                    borderRadius: "20px",
                    px: 2,
                    textTransform: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#fff",
                      transform: "translateX(2px)",
                      boxShadow: "0 4px 10px rgba(13,92,136,0.3)",
                    },
                  }}
                >
                  View All
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </div>
    </Page>
  );
}
